import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/ds-spinner.css';

/**
 * DSSpinner — Design System loading indicator
 *
 * Variants:
 * - "inline"  — sits next to text, no surrounding structure
 * - "page"    — centered in the content area with optional label
 * - "overlay" — absolute overlay over parent (parent needs position:relative)
 * - "button"  — tiny inline spinner for button loading states
 *
 * Sizes: "xs" | "sm" | "md" | "lg"
 */
export function DSSpinner({ variant = 'inline', size = 'md', label, className = '' }) {
  const spinnerEl = (
    <span
      className={`ds-spinner ds-spinner--${size} ${className}`}
      role="status"
      aria-label={label || 'Loading'}
    />
  );

  if (variant === 'button') {
    return spinnerEl;
  }

  if (variant === 'inline') {
    if (!label) return spinnerEl;
    return (
      <span className="ds-spinner-inline">
        {spinnerEl}
        <span className="ds-spinner-label">{label}</span>
      </span>
    );
  }

  // page or overlay
  return (
    <div className={`ds-spinner-${variant}`}>
      {spinnerEl}
      {label && <span className="ds-spinner-label">{label}</span>}
    </div>
  );
}

DSSpinner.propTypes = {
  variant: PropTypes.oneOf(['inline', 'page', 'overlay', 'button']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default DSSpinner;
